const styles = (theme) => ({
  root: {
    padding: "0 10rem",
    zIndex: 10,
    maxWidth: "1700px",
    position: "relative",
    margin: "auto",
    marginTop: "-1px",
    paddingBottom: "210px",
    cursor: "none !important",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1350)]: {
      padding: "0 80px 210px 80px",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
      padding: "0 80px",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
      padding: "0 1rem",
      paddingTop: "80px",
    },
  },
  h1: {
    cursor: "none !important",
    fontFamily: "Montserrat",
    fontWeight: "700",
    fontSize: "60px",
    lineHeight: "75px",
    display: "table",
    letterSpacing: "0.01em",
    color: "black",
    margin: 0,
    marginBottom: "40px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
      fontSize: "32px",
      lineHeight: "38.4px",
      marginBottom: "20px",
    },
  },
  p: {
    cursor: "none !important",
    fontFamily: "Aktiv Grotesk",
    fontWeight: "400",
    fontSize: "1rem",
    display: "table",
    lineHeight: "22.5px",
    letterSpacing: "0.01em",
    color: "black",
    margin: 0,
    marginBottom: "20px",
    maxWidth: "80ch",
  },
});

export default styles;
